// eslint-disable-next-line
const createMarkup = html => ({ __html: html });

export default createMarkup;
